jQuery(document).ready(function(){
  jQuery(".menu-button").click(function () {
    jQuery('body').toggleClass('overflow-hidden');
    jQuery(this).toggleClass("is-active");
    jQuery('#mobile-menu').slideToggle();
  });
});

var galleryThumbs = new Swiper('.gallery-thumbs', {
  spaceBetween: 8,
  slidesPerView: 5,
  freeMode: true,
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
  slideToClickedSlide: true, // Ensure clicking slides changes the top image
});
var galleryTop = new Swiper('.gallery-top', {
  spaceBetween: 10,
  autoHeight:true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true // Ensures smooth fade transitions
  },
  thumbs: {
    swiper: galleryThumbs
  }
});



var exploreProducts = new Swiper('.explore-products', {
    loop: false,
    centeredSlides: true,
    speed: 1000,
    slidesPerView: 5,
    initialSlide:2,
    spaceBetween: 16,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    // Navigation arrows
    // navigation: {
    //   nextEl: '.next-occ',
    //   prevEl: '.prev-occ',
    // },
    breakpoints: {
      300: {
        slidesPerView: 2,
        spaceBetween: 4,
      },
      600: {
        slidesPerView: 2,
        // spaceBetween: 6,
      },
      768: {
        slidesPerView: 3,
        // spaceBetween: 6,
      },
      991: {
        slidesPerView: 4,
        // spaceBetween: 10,
      },
      1200: {
        slidesPerView: 5,
      },
      1300: {
        slidesPerView: 5,
      },
    },
  // spaceBetween: 16,
  // freeMode: true,
  // // loop: true,
  // initialSlide: 4,
  // centeredSlides: true,
  // watchSlidesVisibility: true,
  // watchSlidesProgress: true,
  // slideToClickedSlide: true, // Ensure clicking slides changes the top image
});


document.addEventListener('DOMContentLoaded', function() {
    // Get all dropdown items
    var dropdownItems = document.querySelectorAll('.has-dropdown');

    // Add mouseover event to each dropdown item
    dropdownItems.forEach(function(item) {
        item.addEventListener('mouseover', function() {
            // Add 'hovered-item' class to the hovered item
            this.classList.add('hovered-item');
        });

        item.addEventListener('mouseout', function() {
            // Remove 'hovered-item' class when the mouse leaves the item
            this.classList.remove('hovered-item');
        });
    });

    // Get the main menu element
    var mainMenu = document.getElementById('main-menu');

    // Add mouseleave event to the main menu to rotate the icon back
    mainMenu.addEventListener('mouseleave', function() {
        // Find any items with the 'hovered-item' class and remove it
        var hoveredItems = mainMenu.querySelectorAll('.hovered-item');
        hoveredItems.forEach(function(hoveredItem) {
            hoveredItem.classList.remove('hovered-item');
        });
    });
});